module.exports = __webpack_public_path__ + "img/brightpoint_icon_3.0d1a6cf1.png";